import styled from "@emotion/styled";
import { generatePillStyles } from "../../utils";
import { PillStylesProps } from "./Pill.types";
import { colorGuide, colorPalette } from "../../theme/colors";

export const PillWrapper = styled.div<PillStylesProps>`
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  gap: 4px;
  border-radius: 20px;
  height: 34px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin: 0 8px 8px 0;
  padding: ${({ variant }) =>
    variant === "tag" || variant === "label" ? "0px 8px" : "0px 8px 0px 2px"};
  ${({ selected, variant }) => generatePillStyles({ selected, variant })}
`;

export const ImageWrapper = styled.div<{ containImage?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: ${colorPalette.info[200]};
  overflow: hidden;
  cursor: pointer;
  img {
    width: ${({ containImage }) => (containImage ? "100%" : "unset")};
    height: ${({ containImage }) => (containImage ? "100%" : "unset")};
    object-fit: ${({ containImage }) => (containImage ? "cover" : "unset")};
  }
`;

export const CloseIconWrapper = styled.div`
  display: flex;
  width: 18px;
  height: 18px;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
`;
export const PillContent = styled.div`
  display: flex;
  padding: 8px 0px;
  align-items: center;
  gap: 4px;
`;
export const StyledIcon = styled.i`
  font-size: 12px;
  color: ${colorGuide.lightComponents.pills.tag.selected.iconColor};
`;
